var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgResource = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "31px",
    viewBox: "0 0 25 31",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Available Filters - 01")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BITACore-Resources-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-913.000000, -243.000000)",
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(846.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(17.000000, 122.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(11.804878, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Action-/-book",
    transform: "translate(33.164298, 0.210672)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 35.7 0 35.7 36.75 0 36.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.775,3.0625 L8.925,3.0625 C7.28875,3.0625 5.95,4.440625 5.95,6.125 L5.95,30.625 C5.95,32.309375 7.28875,33.6875 8.925,33.6875 L26.775,33.6875 C28.41125,33.6875 29.75,32.309375 29.75,30.625 L29.75,6.125 C29.75,4.440625 28.41125,3.0625 26.775,3.0625 Z M13.3875,6.125 L16.3625,6.125 L16.3625,13.78125 L14.875,12.6328125 L13.3875,13.78125 L13.3875,6.125 Z M26.775,30.625 L8.925,30.625 L8.925,6.125 L10.4125,6.125 L10.4125,19.90625 L14.875,16.4609375 L19.3375,19.90625 L19.3375,6.125 L26.775,6.125 L26.775,30.625 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF"
  })))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgResource, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/resource.b6ff8ba2.svg";
export { ForwardRef as ReactComponent };